import { ActionTypes } from "../constantes/ActionTypes";
import axios from "../../../../common/axios";
import { shipmentInfoSuccess } from "../actions/ShipmentByUserAction";

export const shipmentDeleteStart = (action) => {
  return (dispatch) => {
    dispatch(action);
    axios
      .get(
        `/deleteShipment?id=${action.payload}`
      )
      .then((response) => {
        dispatch(shipmentDeleteSuccess(response.data));

        let newData = action.data.list.filter((x) => {
          return x.id != action.payload;
        });
        let objectParam = { ...action.data, ...{ list: newData } };
        dispatch(shipmentInfoSuccess(objectParam));
      })
      .catch((error) => {
        dispatch(shipmentDeleteFailed(error.response?.data));
      });
  };
};

export const shipmentDeleteSuccess = (shipmentInfo) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_DELETE_SUCCESS,
    payload: shipmentInfo,
  };
};

export const shipmentDeleteFailed = (error) => {
  return {
    type: ActionTypes.ACTION_SHIPMENT_DELETE_FAILED,
    payload: error,
  };
};
